jQuery(function($){    
    
 $('header.site_header ul.top_menu li.has_dropdown').hover(
  function() {
     $('.menu_slider').slick('setPosition');
  });
  
  $('.ham_menu').on('click',function(){
    console.log('hello');
    $('header.site_header ul.top_menu').slideToggle();
});
    
    
$('.mega_drop .list-unstyled > li').hover(function() {
    
    $(".mega_drop .list-unstyled > li").removeClass("selected");
    var index = $(this).index();
    $(this).addClass("selected");
    $(".right_panel > div.innerpanel").hide();
    $(".right_panel > div.innerpanel:eq(" + index + ")").show();
    $(".right_panel > div.innerpanel:eq(" + index + ")").find('.menu_slider').slick('setPosition');
});
   
   
  $('.menu_slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
	infinite:false,
	prevArrow:'<button type="button" class="slick-prev"><span class="icon-right-arrow"></span></button>',
	nextArrow:'<button type="button" class="slick-next"><span class="icon-right-arrow"></span></button>',
  	autoplaySpeed: 3000,
    adaptiveHeight: true,
 	arrows: true,
	dots:false,
 	focusOnSelect: true,
		responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 3,
	        slidesToScroll: 1
	      }
	    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
	{
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
 }); 
    
    
    
    
$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav'
});
    
    
$('.slider-nav').slick({
  slidesToShow: 3,
  vertical: true,
  slidesToScroll: 1,
  infinite:false,
  asNavFor: '.slider-for',
  dots: false,
  centerMode: false,
  prevArrow:'<button type="button" class="slick-prev"><span class="icon-right-arrow"></span></button>',
  nextArrow:'<button type="button" class="slick-next"><span class="icon-right-arrow"></span></button>',
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: false,
      }
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
$('.slider-for .slick-slide').zoom();
    
    
 //$('.count').prop('disabled', true);
    $(document).on('click','.minus',function(){
        $('.count').val(parseInt($('.count').val()) + 1 );
    });
    $(document).on('click','.plus',function(){
        $('.count').val(parseInt($('.count').val()) - 1 );
        if ($('.count').val() == 0) {
            $('.count').val(1);
        }
}); 
  
//   $('.spr-reviews').load(function(){
//         $('.spr-summary-actions a.spr-summary-actions-newreview').addClass('shop_bttn');
    
//   		$('.spr-summary-actions').appendTo('.spr-header-title'); 
//     });
  
  
    
    
});


/*  Mailchimp Subscribe  */
$('#mc-embedded-subscribe-form').bind('submit', function(event) {
   event.preventDefault(); //prevent page refresh
//    var name  = $('[name="client_name"]').val();//get name field value
   var email = $('[name="EMAIL"]').val();//get email field value
//   
  $.ajax({
        type: "POST",
        url: "https://mailchimp-proxy-stickyfingers.herokuapp.com/api/member",
        dataType: 'json',
    	data:  {EMAIL:email},
        success: function(data) {
          $('#mc_embed_signup').html("Thank you!");
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
    });//EO ajax
});//EO click bind